module.exports = __webpack_public_path__ + "static/scale-model-of-san-mateo-california-ff9ce42b108b5ec7663d6523f6bc4b31.png";